import { useState } from "react";
import { motion } from "framer-motion";
import { X, ZoomIn } from "lucide-react";
import { GALLERY } from "../data";

export const Gallery = () => {
  const [active, setActive] = useState(null);

  return (
    <section
      id="realizacje"
      data-testid="gallery-section"
      className="bg-white py-16 md:py-24"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="font-anton uppercase text-[#DC2626] tracking-widest text-sm">
            Realizacje
          </span>
          <h2 className="font-anton uppercase text-[#09090B] text-4xl md:text-5xl mt-3 leading-tight">
            Przykładowe prace
          </h2>
          <p className="mt-3 text-zinc-600">
            Zobacz przykładowe prace wykonywane sprzętem Bobcat.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {GALLERY.map((img, i) => (
            <motion.button
              key={img.label}
              data-testid={`gallery-item-${i}`}
              onClick={() => setActive(img)}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: (i % 2) * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="group relative border-2 border-[#09090B] overflow-hidden block h-64 md:h-80 hover:shadow-[8px_8px_0_0_rgba(220,38,38,1)] transition-all duration-300"
            >
              <img
                src={img.src}
                alt={img.alt}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#09090B]/85 via-[#09090B]/25 to-transparent" />
              <span className="absolute top-4 left-4 h-0.5 w-10 bg-[#DC2626] group-hover:w-20 transition-all duration-300" />
              <span className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity">
                <ZoomIn size={22} className="text-white" />
              </span>
              <div className="absolute bottom-4 left-4 right-4 text-left">
                <span className="font-anton uppercase text-white text-lg md:text-xl leading-tight block">
                  {img.label}
                </span>
                {img.desc && (
                  <span className="mt-1 block text-zinc-200 text-xs md:text-sm leading-snug">
                    {img.desc}
                  </span>
                )}
              </div>
            </motion.button>
          ))}
        </div>
      </div>

      {active && (
        <div
          data-testid="gallery-lightbox"
          onClick={() => setActive(null)}
          className="fixed inset-0 z-[60] bg-black/90 flex items-center justify-center p-4"
        >
          <button
            data-testid="gallery-lightbox-close"
            onClick={() => setActive(null)}
            className="absolute top-5 right-5 text-white border-2 border-white p-2 hover:bg-[#DC2626] hover:border-[#DC2626] transition-colors"
            aria-label="Zamknij"
          >
            <X size={24} />
          </button>
          <figure onClick={(e) => e.stopPropagation()} className="max-w-5xl">
            <img
              src={active.src}
              alt={active.alt}
              className="max-w-full max-h-[80vh] object-contain border-2 border-white"
            />
            <figcaption className="mt-3 font-anton uppercase text-white text-center tracking-wide">
              {active.label}
            </figcaption>
          </figure>
        </div>
      )}
    </section>
  );
};

